import { PhoneOff } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { useMeetingSession } from '@/lib/meetings/meeting-session-context'

/**
 * "You will leave the meeting if you switch project" (board fqw7). The
 * session provider blocks every navigation out of the project while a
 * meeting is live — the project switcher, Settings, the admin pages, the
 * project list — and this dialog resolves it: confirming leaves for real
 * (media stopped, socket closed, the room writes the leave row) and then
 * proceeds; cancelling stays.
 */
export function LeaveProjectDialog() {
  const { t } = useTranslation('meet')
  const { exit } = useMeetingSession()
  return (
    <AlertDialog open={exit.pending} onOpenChange={(open) => !open && exit.cancel()}>
      <AlertDialogContent data-testid="leave-project-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>{t('leaveProject.title')}</AlertDialogTitle>
          <AlertDialogDescription>{t('leaveProject.description')}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t('leaveProject.cancel')}</AlertDialogCancel>
          <AlertDialogAction
            variant="destructive"
            onClick={(event) => {
              // Radix closes on Action by default; the blocker's `proceed`
              // unmounts this layout anyway once the leave has gone through.
              event.preventDefault()
              exit.confirm()
            }}
          >
            <PhoneOff className="h-4 w-4" />
            {t('leaveProject.confirm')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
